import { text } from '#contract'
import { useT } from '../../i18n/index.ts'
import { PhoneIcon } from '../icons/app-icons.tsx'
import { AppEmptyState } from './app-empty-state.tsx'
import styles from './apps.module.css'

/** Phone (phone only): recent calls, none yet. */
export function PhoneApp() {
  const t = useT()
  return (
    <div class={styles.app}>
      <header class={styles.header}>
        <h1 class={styles.title}>{t(text('os.app.phone.recents'))}</h1>
      </header>
      <AppEmptyState id="phone" icon={PhoneIcon} />
    </div>
  )
}
